<template>
  <app-dialog
    v-model="openModel"
    content-class="dialogGuaranteeInjury guaranteeModal"
    @onClose="$emit('onClose')"
  >
    <template v-slot:title>
      <h1 class="dialogGuaranteeInjury-title">ケガの保障</h1>
    </template>
    <v-card class="dialogGuaranteeInjury-content">
      <v-card-text class="dialogGuaranteeInjury-content">
        <div class="his-tbl_wrapper">
          <table>
            <thead>
              <tr>
                <th colspan="5">保障内容</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th></th>
                <th>Ｅ型</th>
                <th>Ｊ型</th>
                <th>Ｋ型</th>
              </tr>
              <tr>
                <td>１口<br />あたりの<br />保障額</td>
                <td data-label="Ｅ型">
                  <table>
                    <tbody>
                      <tr>
                        <th>入院</th>
                        <td>１，５００円/日</td>
                      </tr>
                      <tr>
                        <th rowspan="3">手術</th>
                        <td>(外来)<br />入院保険金日額の１０倍</td>
                      </tr>
                      <tr>
                        <td>(入院)<br />入院保険金日額の２０倍</td>
                      </tr>
                      <tr>
                        <td>(重大)<br />入院保険金日額の４０倍</td>
                      </tr>
                      <tr>
                        <th>通院</th>
                        <td>１，０００円/日</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td data-label="Ｊ型">
                  <table>
                    <tbody>
                      <tr>
                        <th>死亡</th>
                        <td>１００万円</td>
                      </tr>
                      <tr>
                        <th>後遺障害</th>
                        <td>障害の程度に応じて<br />４万円～１００万円</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td data-label="Ｋ型">
                  <table>
                    <tbody>
                      <tr>
                        <th>後遺障害</th>
                        <td>障害の程度に応じて<br />４万円～１００万円</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td>ご加入条件</td>
                <td data-label="Ｅ型">単独加入が可能</td>
                <td data-label="Ｊ型">
                  J型・K型のいずれか<br />一方のみ単独加入が可能
                </td>
                <td data-label="Ｋ型">
                  J型・K型のいずれか<br />一方のみ単独加入が可能
                </td>
              </tr>
              <tr>
                <td>口数の制限</td>
                <td data-label="Ｅ型">1～10口の範囲内</td>
                <td data-label="Ｊ型">1～20口の範囲内</td>
                <td data-label="Ｋ型">1～20口の範囲内</td>
              </tr>
            </tbody>
          </table>
          <div>
            <div class="pointTitle">特長</div>
            <div class="pointBox">
              <dl>
                <dt>1</dt>
                <dd>
                  <strong>急激・偶然・外来の事故によるケガを24時間保障</strong>
                </dd>
              </dl>
              <dl>
                <dt>2</dt>
                <dd>
                  地震や津波など<br /><strong>天災によるケガも保障</strong>
                </dd>
              </dl>
              <dl>
                <dt>3</dt>
                <dd><strong>満84歳まで</strong><br />継続加入が可能</dd>
              </dl>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </app-dialog>
</template>

<script>
export default {
  name: 'DialogGuaranteeInjury',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    openModel: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style lang="scss">
.dialogGuaranteeInjury {
  width: 690px;
  max-width: 700px;
  &-content {
    &.v-card__text {
      padding: 0 25px 20px;
    }
  }
  &-title {
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: center;
    color: #333;
    margin-top: 15px;
    margin-bottom: 5px;
    width: 100%;
  }
}
</style>
